import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-ref": "title" }

import { Tooltip } from 'bootstrap';

import {
  onMounted,
  ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
  trigger: {
    type: String,
    required: false,
    default: () => 'hover focus',
  },
},
  setup(__props) {



const root = ref<InstanceType<typeof HTMLElement>>();
const tooltip = ref<Tooltip | null>(null);

onMounted(() => {
  const title = root.value?.querySelector('[data-ref="title"]');

  if (root.value && title) {
    tooltip.value = new Tooltip(root.value, {
      html: true,
      title: title.innerHTML,
    });

    title.remove();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "io-tooltip"
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "title")
    ])
  ], 512))
}
}

})